import { Component, Input, Output, EventEmitter, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import Session from "../../utils/session.service";
import AngularFilterHelperService from "../../services/angular-filter-helper.service";
import DialogServices from "../../services/dialog.service";
import {ModalBookingRequestResponseComponent} from "../modal-booking-request-response/modal-booking-request-response.component";

@Component({
    standalone: true,
    selector: 'table-booking-requests',
    templateUrl: './table-booking-requests.component.html',
    imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent ]
})
export class TableBookingRequestsComponent implements OnInit {
    private dialogServices: DialogServices = inject(DialogServices);
    private session: Session = inject(Session);
    private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);

    @Input() requests: any[] = [];
    @Output() answered = new EventEmitter<any>();

    vm: any = this;
    loading = false;

    ngOnInit(): void {
        this.vm.loading = false;
        this.vm.user = this.session.getSession().user;
        this.vm.isDoctor = !!(this.vm.user.businessUserType === 'SERVICE_PROVIDER');
    }


    reply(request: any): void {
        if (!request) return;
        this.dialogServices.show({
            controller: ModalBookingRequestResponseComponent,
            request: request
        });
    }
}
